import React from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const galleryImages = [
  {
    url: '/images/Maria-Grant-Writing-3.jpg',
    caption: 'Grant Writing Workshop Session',
    position: 'center'
  },
  {
    url: '/images/NIERA-Dissemination.jpg',
    caption: 'NIERA Research Dissemination Event',
    position: 'center'
  },
  {
    url: '/images/Paul-Capacity-Building-2.jpg',
    caption: 'Capacity Building Workshop',
    position: 'center'
  },
  {
    url: '/images/Paul-Capacity-Building-3.jpg',
    caption: 'Capacity Building Workshop',
    position: 'center'
  },
  {
    url: '/images/Maria-French-Development-Agency-1.jpg',
    caption: 'French Development Agency Meeting',
    position: 'center'
  },
  {
    url: '/images/Maria-French-Development-Agency-2.jpg',
    caption: 'French Development Agency Meeting',
    position: 'center'
  },
  {
    url: '/images/Maria-National-Green-Taxonomy.jpg',
    caption: '3rd Technical Committee Meeting for development of Uganda\'s National Green Taxonomy',
    position: 'center'
  },
  {
    url: '/images/Maria-National-Green-Taxonomy-1.jpg',
    caption: '3rd Technical Committee Meeting for development of Uganda\'s National Green Taxonomy',
    position: 'center 40%' // Adjusted position for this specific image
  },
  {
    url: '/images/Maria-Oil&Gas-Workshop.jpg',
    caption: 'Uganda Oil & Gas Transition Workshop',
    position: 'center'
  },
  {
    url: '/images/Maria-REC24.jpg',
    caption: 'Uganda Renewable Energy Conference 2024 Participation',
    position: 'center'
  },
  {
    url: '/images/Paul-Capacity-Building-4.jpg',
    caption: 'Advanced Capacity Building Program',
    position: 'center'
  },
  {
    url: '/images/Paul-NDC-Checklist-Pilot-Program.jpg',
    caption: 'NDC Checklist Pilot Program by MoFPED in collaboration with NDC Partnership & CrossBoundary',
    position: 'center'
  },
  {
    url: '/images/Paul-NDC-Checklist-Pilot-Program-1.jpg',
    caption: 'NDC Checklist Pilot Program by MoFPED in collaboration with NDC Partnership & CrossBoundary',
    position: 'center'
  }
];

export default function EventsGallery() {
  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-white">Event Gallery</h2>
          <p className="mt-4 text-xl text-gray-300">
            Moments captured from our workshops, conferences, and capacity building programs
          </p>
        </motion.div>

        <Swiper
          modules={[Pagination, Autoplay, Navigation]}
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }}
          pagination={{ clickable: true }}
          navigation
          autoplay={{ 
            delay: 5000,
            disableOnInteraction: false 
          }}
          className="pb-12"
        >
          {galleryImages.map((image, index) => (
            <SwiperSlide key={index}>
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="bg-white rounded-lg shadow-md overflow-hidden h-[360px] flex flex-col"
              >
                {/* Image container with fixed height and custom position */}
                <div className="h-[280px] overflow-hidden">
                  <img
                    src={image.url}
                    alt={image.caption}
                    className="w-full h-full object-cover"
                    style={{ objectPosition: image.position }}
                    loading="lazy"
                  />
                </div>
                {/* Caption container with fixed height */}
                <div className="flex-1 p-3 bg-white flex items-center">
                  <p className="text-gray-800 text-sm font-medium line-clamp-2">
                    {image.caption}
                  </p>
                </div>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}